/* tslint:disable */
/* eslint-disable */

/**
 * 0 = FullTime
 * 
 * 1 = PartTime
 */
export enum EmploymentType {
  FullTime = 0,
  PartTime = 1
}
